import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {RestApiService} from '../../_services/rest-api.service';
import {NuevaSolicitud} from '../../_models/nueva-solicitud.model';
import {Autorizacion} from '../../_models/autorizacion.model';
import {UIService} from '../../_services/ui.service';
import {Cliente} from '../../_models/cliente.model';
import {ClienteService} from '../../_services/cliente.service';
import {AuthResponse} from '../../_models/auth-response.model';
import {Sources} from '../../_models/sources.model';
import {SourcesService} from '../../_services/sources.service';
import {HttpErrorResponse} from '@angular/common/http';
import {UntypedFormGroup} from '@angular/forms';
import {AuthorizationService} from '../../_services/authorization.service';
import {ResponseStatus} from '../../_enums/response-status.enum';
import {OnboardingStep} from '../../_enums/onboarding-step.enum';
import {finalize, take} from 'rxjs/operators';
import {OnboardingService} from '../../_services/onboarding-steps.service';
import {BehaviorSubject, Subscription} from 'rxjs';
import {TitleService} from '../../_services/title.service';
import {StyleServiceService} from '../../_services/style-service.service';
import {ErrorPageService} from 'src/app/_services/error-page.service';
import {Router} from '@angular/router';
import {Routes} from 'src/app/_enums/routes.enum';
import {ErrorMessage} from 'src/app/_enums/error-message.enum';
import {Step} from '../../_enums/step.enum';
import {Gender} from '../../_enums/gender.enum';
import {LogType} from '../../_enums/log-type.enum';
import {InternalErrorCode} from '../../_enums/internal-error-code.enum';
import {MatDialog} from '@angular/material/dialog';
import {CartelServiciosDialogComponent} from '../../component/cartel-servicios-dialog/cartel-servicios-dialog.component';
import {ofreceSelectorDeServicios} from '../../component/new-client/new-client.component';

@Component({
	selector: 'app-datos-personales',
	templateUrl: './datos-personales.component.html',
	styleUrls: ['./datos-personales.component.css'],
})
export class DatosPersonalesComponent implements OnInit {
	public useCredilowStyle: boolean;
	private autorizacion: Autorizacion = new Autorizacion();
	private nuevaSolicitud: NuevaSolicitud = new NuevaSolicitud();
	private sources: Sources = new Sources();

	public cliente: Cliente = new Cliente();
	public loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private clienteServiceSubscription: Subscription;
	private monitoringLogSubscription: Subscription;

	constructor(
		public styleService: StyleServiceService,

		private readonly restApiService: RestApiService,
		private readonly autorizacionService: AuthorizationService,
		private readonly clienteService: ClienteService,
		private readonly uIService: UIService,
		private readonly onboardingService: OnboardingService,
		private readonly fuentesService: SourcesService,
		private titleService: TitleService,
		private errorPageService: ErrorPageService,
		private readonly dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.titleService.updateTitle('Datos personales');
		this.autorizacionService.getAutorizacion().subscribe({
			next: (autorizacion: Autorizacion) => (this.autorizacion = autorizacion),
			error: (error: Error) => console.log(error),
		});
		this.clienteServiceSubscription = this.clienteService
			.getCliente()
			.pipe(take(1))
			.subscribe({
				next: (cliente: Cliente) => {
					this.cliente = cliente;
					this.restApiService
						.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.StartDatosPersonales, logType: LogType.Flujo})
						.subscribe(() => {
							this.unsubscribe();
						});
				},
				error: (error: Error) => console.log(error),
			});
		this.fuentesService.getFuentes().subscribe({
			next: (sources: Sources) => (this.sources = sources),
			error: (error: Error) => console.log(error),
		});
		this.styleService.useCredilowStyle.subscribe((useCredilowStyle) => {
			this.useCredilowStyle = useCredilowStyle;
		});
	}

	private unsubscribe(): void {
		if (this.clienteServiceSubscription && !this.clienteServiceSubscription.closed) {
			this.clienteServiceSubscription.unsubscribe();
		}
	}

	public fillClient(formGroupData: UntypedFormGroup, newClient: boolean) {
		const mobilePhoneInput = formGroupData.controls.mobilePhone.value;
		this.cliente.celular = mobilePhoneInput.charAt(0) === '*' ? this.cliente.celular : mobilePhoneInput;
		this.cliente.comercio = formGroupData.controls.commerce.value;
		if (newClient) {
			this.cliente.trabajoEnBlanco = formGroupData.controls.blankJob.value;
			this.cliente.telefonoFijo = formGroupData.controls.homePhone.value;
			/* La cantidad viaja solo si el vendedor la eligió con el selector a la vista (la misma condición que
			   lo muestra); si no, va vacía: un reintento del alta en un comercio sin plan DNI a nuevos arrastraba
			   la elegida en el intento anterior. #9676 */
			this.cliente.cantidadServicios = ofreceSelectorDeServicios(formGroupData)
				? formGroupData.controls.amountOfServices.value
				: null;
		}
		this.nextStep();
	}

	private removeLeadingZeros(telefonoFijo: number): number {
		if (telefonoFijo === null || telefonoFijo === undefined) {
			return null;
		}
		const sanitizedValue = telefonoFijo.toString().replace(/^0+/, ''); // Remove leading zeros
		return parseInt(sanitizedValue, 10); // Convert back to number
	}

	private nextStep(): void {
		this.loading.next(true);
		this.nuevaSolicitud.nuevo = this.cliente.nuevo;
		this.nuevaSolicitud.comercio = this.cliente.comercio.Id;
		this.nuevaSolicitud.sexo = this.cliente.sexo;
		this.nuevaSolicitud.dni = this.cliente.dni;
		this.nuevaSolicitud.celular = this.cliente.celular;
		this.nuevaSolicitud.fijo = this.removeLeadingZeros(this.cliente.telefonoFijo);
		this.nuevaSolicitud.empleo = this.cliente.trabajoEnBlanco;
		this.nuevaSolicitud.fechaNacimiento = this.cliente.fechaNacimiento;
		this.nuevaSolicitud.tarjeta = this.cliente.tarjeta;
		this.nuevaSolicitud.validationId = this.cliente.validationId;
		this.nuevaSolicitud.cantServicios = this.cliente.cantidadServicios;
		this.nuevaSolicitud.acceptedUnderCommerceRiskDate = this.autorizacionService.getAcceptedUnderCommerceRisk();
		this.restApiService
			.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.NuevaSolicitudInicio, logType: LogType.Flujo})
			.subscribe();
		this.restApiService
			.nuevaSolicitud(this.nuevaSolicitud)
			.pipe(
				finalize(() => {
					this.loading.next(false);
				})
			)
			.subscribe({
				next: (data: AuthResponse) => {
					if (data.hasOwnProperty('status') && data.status !== 'error') {
						//@TURBIO VIENE DEL BACK ASI
						this.uIService.responseLog('nuevaSolicitud - OK', data);
						this.restApiService
							.monitoringLog({
								creditFlowId: this.cliente.creditFlowId,
								step: Step.NuevaSolicitud,
								logType: LogType.Flujo,
								authId: data.authId,
							})
							.subscribe();

						this.autorizacion.id = data.authId;
						this.autorizacion.reporteRecienteAprobado = data.reporteRecienteAprobado;
						this.autorizacion.comercio = this.cliente.comercio;
						this.cliente.renovador = data.renovador;
						this.cliente.tipo = data.tipo;
						this.clienteService.setCliente(this.cliente);
						this.autorizacionService.setAutorizacion(this.autorizacion);
						this.onboardingService.moveTo(OnboardingStep.ClientData);
						this.validarFuentes();
					} else {
						this.uIService.errorMessage('Error!', data.message);
						this.uIService.responseLog('nuevaSolicitud - ERROR', data);
						this.restApiService
							.monitoringLog({
								creditFlowId: this.cliente.creditFlowId,
								step: Step.NuevaSolicitud,
								logType: LogType.Consola,
								error: data.message,
								authId: data.authId,
							})
							.subscribe();
					}
				},
				error: (error: HttpErrorResponse) => {
					this.restApiService
						.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.NuevaSolicitud, logType: LogType.Consola, error})
						.subscribe();
					if (error.error.code === ErrorMessage.AASException) {
						this.uIService.errorMessage('Error!', error.error.payload.scalar);
						this.uIService.responseLog('nuevaSolicitud - ERROR', error.error);
					} else {
						this.uIService.errorMessage('Error!', error.error);
						this.uIService.responseLog('nuevaSolicitud - ERROR', error.error.message);
					}
				},
			});
	}

	private validarFuentes(): void {
		if (this.autorizacion.reporteRecienteAprobado) {
			this.correrReporteCrediticio();
			return;
		}
		this.restApiService
			.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.StartValidarFuentes, logType: LogType.Flujo})
			.subscribe();
		setTimeout(() => {
			this.restApiService.estadoFuentes(this.autorizacion.id).subscribe({
				next: (data: any) => {
					if (data.status == 'error') {
						this.uIService.responseLog('estadoFuentes - ERROR', data);
						this.restApiService
							.monitoringLog({
								creditFlowId: this.cliente.creditFlowId,
								step: Step.ValidarFuentes,
								logType: LogType.Consola,
								error: data,
							})
							.subscribe();
						this.errorPageService.setError(data.message, null, null, Routes.CreateCredit);
						return;
					} else {
						this.uIService.responseLog('estadoFuentes - OK', data);
						if (!data.resultado) {
							this.restApiService
								.monitoringLog({
									creditFlowId: this.cliente.creditFlowId,
									step: Step.ValidarFuentes,
									logType: LogType.Consola,
									error: data,
								})
								.subscribe();
							this.uIService.errorMessage('Error', data.novedad);
							this.errorPageService.setError(data.message, null, null, Routes.CreateCredit);

							return;
						}
						this.fuentesService.setFuentes(data);
						if (this.sources.checked === this.sources.count) {
							this.restApiService
								.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.ValidarFuentes, logType: LogType.Flujo})
								.subscribe();
							this.correrReporteCrediticio();
						} else {
							this.validarFuentes();
							return;
						}
					}
				},
				error: (error: HttpErrorResponse) => {
					this.restApiService
						.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.ValidarFuentes, logType: LogType.Consola, error})
						.subscribe();
					this.errorPageService.setError(
						'Error de Nosis',
						'Error al consultar el reporte crediticio. Por favor, reintenta dentro de unos minutos',
						null,
						Routes.CreateCredit
					);
					this.uIService.responseLog('estadoFuentes - ERROR', error);
				},
			});
		}, 5000);
	}

	private correrReporteCrediticio(): void {
		this.restApiService
			.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.StartReporteCrediticio, logType: LogType.Flujo})
			.subscribe();
		this.restApiService.correrReporteCrediticio(this.autorizacion.id).subscribe({
			next: (data: AuthResponse) => {
				if (data.status === ResponseStatus.Wait) {
					this.uIService.responseLog('correrReporteCrediticio - OK', data);
					this.correrReporteCrediticio();
					return;
				} else if (data.status === ResponseStatus.Success) {
					// Cartel de servicios para fijar la línea DNI real (POST ac/cantServicios). Si hay
					// que preguntar lo decide el back (Aprobacion::debePreguntarCantServicios): no
					// renovador en línea DNI por servicios que todavía no eligió cuántos presenta, y en
					// un comercio donde preguntar sirve. Acá solo se lee la marca. #9674
					if (data.preguntarCantServicios) {
						this.restApiService
							.monitoringLog({
								creditFlowId: this.cliente.creditFlowId,
								step: Step.ReporteCrediticio,
								logType: LogType.Flujo,
							})
							.subscribe();
						this.uIService.responseLog('correrReporteCrediticio - EMPLEO NO VERIFICA', data.message);
						this.mostrarCartelServicios(data.dni, data.nombre);
						return;
					}
					this.uIService.responseLog('correrReporteCrediticio - OK', data);
					this.restApiService
						.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.ReporteCrediticio, logType: LogType.Flujo})
						.subscribe();
					this.getMontoMaximo();
					return;
				} else {
					this.uIService.responseLog('Error', data.message);
					this.uIService.responseLog('correrReporteCrediticio - ERROR', data);
					this.restApiService
						.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.ReporteCrediticio, logType: LogType.Consola, error: data})
						.subscribe();
					this.loading.next(false);
					this.onboardingService.restart();
					this.clienteService.restart();
					this.errorPageService.setError(data.message, null, null, Routes.Home);
					return;
				}
			},
			error: (error: HttpErrorResponse) => {
				this.restApiService
					.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.ReporteCrediticio, logType: LogType.Consola, error})
					.subscribe();
				this.uIService.responseLog('correrReporteCrediticio - ERROR', error);
				this.errorPageService.setError(error.message, null, null, Routes.Home);
			},
		});
	}

	private mostrarCartelServicios(dni: string, nombre: string, cantServiciosPrevia?: number): void {
		const dialogRef = this.dialog.open(CartelServiciosDialogComponent, {
			width: '500px',
			disableClose: true,
			/* closeOnNavigation queda en su default (true) A PROPÓSITO: con el atrás del celular
			   no hay CanDeactivate ni handler de popstate en el repo, así que es una navegación de
			   router real. Con closeOnNavigation:false el modal quedaba pegado sobre /home, sin ESC
			   ni backdrop por el disableClose — un cartel indescartable de un wizard muerto. El
			   default cierra, cae en la rama de cancelación y avisa. #9219 */
			ariaDescribedBy: 'cartel-serv-pregunta',
			/* La pantalla de atrás (ClientData) muestra el nombre vacío en este punto del wizard,
			   así que el cartel lleva la identidad: el operador tiene que saber de qué cliente
			   está fijando la línea de crédito. #9219 */
			data: {dni: dni, nombre: nombre, cantServicios: cantServiciosPrevia},
		});
		dialogRef.afterClosed().subscribe((cantServicios: number) => {
			if (cantServicios === undefined || cantServicios === null) {
				// Cancelar: la aprobación queda viva del lado del servidor, así que abandonar
				// es recuperable. Sin esto el reintento por red caída no tenía salida. #9219
				this.onboardingService.restart();
				this.clienteService.restart();
				this.errorPageService.setError(
					'Solicitud cancelada',
					'Podés iniciar una nueva solicitud cuando quieras.',
					null,
					Routes.Home
				);
				return;
			}
			this.confirmarCantServicios(cantServicios, dni, nombre);
		});
	}

	private confirmarCantServicios(cantServicios: number, dni: string, nombre: string): void {
		this.loading.next(true);
		this.restApiService.cantServicios(this.autorizacion.id, cantServicios).pipe(finalize(() => this.loading.next(false))).subscribe({
			next: (data: any) => {
				if (data?.status === ResponseStatus.Success) {
					this.uIService.responseLog('cantServicios - OK', data);
					this.getMontoMaximo();
					return;
				}
				if (!data) {
					/* Body vacío en un 200 (proxy, redirect de sesión): NO es un rechazo del back
					   sino una anomalía de transporte, así que es reintentable — mismo criterio que
					   la rama error de abajo y que AA-Frontend (showCartelServicios = !result). Solo
					   un status error EXPLÍCITO es terminal. #9219 */
					this.uIService.responseLog('cantServicios - ERROR (body vacío)', data);
					this.uIService.errorMessage('Error', 'No pudimos registrar la respuesta. Reintentá o cancelá.');
					this.mostrarCartelServicios(dni, nombre, cantServicios);
					return;
				}
				// data con status distinto de success = rechazo explícito del back → terminal.
				this.uIService.responseLog('cantServicios - ERROR', data);
				this.restApiService
					.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.ReporteCrediticio, logType: LogType.Consola, error: data})
					.subscribe();
				this.onboardingService.restart();
				this.clienteService.restart();
				this.errorPageService.setError(data?.message ?? 'No pudimos registrar la respuesta.', null, null, Routes.Home);
			},
			error: (error: HttpErrorResponse) => {
				this.restApiService
					.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.ReporteCrediticio, logType: LogType.Consola, error})
					.subscribe();
				this.uIService.responseLog('cantServicios - ERROR', error);
				/* Falla de TRANSPORTE (red caída, timeout): la aprobación sigue viva del lado del
				   servidor, así que no se tira la solicitud — se reabre el cartel para reintentar,
				   igual que hace AA-Frontend. Solo el status error del back es terminal. #9219 */
				this.uIService.errorMessage('Error', 'No pudimos registrar la respuesta. Reintentá o cancelá.');
				// Conserva la selección: en red intermitente reelegir en cada reintento es fricción.
				this.mostrarCartelServicios(dni, nombre, cantServicios);
			},
		});
	}

	private getMontoMaximo(): void {
		// this.restApiService.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.BeforeMontoMaximo, logType:LogType.Flujo}).subscribe();
		this.restApiService.getMontoMaximo(this.autorizacion.id).subscribe({
			next: (data: AuthResponse) => {
				if (data.status === ResponseStatus.Wait) {
					this.getMontoMaximo();
					return;
				} else if (data.status === ResponseStatus.Success) {
					// this.restApiService.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.MontoMaximo, logType:LogType.Flujo}).subscribe();
					this.uIService.responseLog('getMontoMaximo - OK', data);
					this.autorizacion.montoMaximo = data.monto;
					this.autorizacionService.setAutorizacion(this.autorizacion);
					return;
				} else if (data.status === ResponseStatus.Error) {
					this.restApiService
						.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.MontoMaximo, logType: LogType.Consola, error: data})
						.subscribe();
					this.loading.next(false);
					this.uIService.responseLog('getMontoMaximo - ERROR', data);
					/* Corte terminal: la aprobación queda en estado='error' server-side (brick del 9203),
					   así que el wizard ya no se puede completar. Un toast con autodismiss dejaba al
					   usuario parado y sin el motivo a la vista. Mismo patrón que las hermanas. #9217 */
					this.onboardingService.restart();
					this.clienteService.restart();
					this.errorPageService.setError(data.message, null, null, Routes.Home);
					return;
				}
			},
			error: (error: HttpErrorResponse) => {
				this.loading.next(false);
				this.restApiService
					.monitoringLog({creditFlowId: this.cliente.creditFlowId, step: Step.MontoMaximo, logType: LogType.Consola, error})
					.subscribe();
				this.uIService.responseLog('getMontoMaximo - ERROR', error);
				this.errorPageService.setError(error.error.message, error.error.payload.scalar, null, Routes.CreateCredit);
			},
		});
	}

	ngOnDestroy(): void {
		this.unsubscribe();
	}
}
